import React, { useContext } from 'react'
import { FileExcel, FilePdf } from 'react-bootstrap-icons';
import { NavLink } from 'react-router';
import Export from '../../pdf/Export';
import { formattedText } from '../../services/Fonctions';
import Pagination from '../components/Pagination';
import { RechercheContext } from '../Recherche';

function ResultatZambie({ data }) {

    const provider = useContext(RechercheContext);

    const toExcel = () => {
        if (data.nombre > 1000) alert("Limite 1000 déclarations dépassable");
        else provider.exportExcel();
    }

    return (
        <>
            <div className='d-flex justify-content-between'>
                <div>
                    Total Résultat : {data.nombre}
                </div>
                <div>
                    <button className='btn btn-success me-2' onClick={toExcel}><FileExcel className='fs-3' /></button>
                    <button className='btn btn-danger' onClick={() => { new Export().zraListe(data.data) }}><FilePdf className='fs-3' /></button>
                </div>
            </div>
            <div className='table-responsive'>
                <table className='table table-hover' style={{ fontSize: '12px' }}>
                    <thead>
                        <tr>
                            <th>Véhicule</th>
                            <th>Importateur</th>
                            <th>Déclaration</th>
                            <th>Date</th>
                            <th>Modèle</th>
                            <th>Articles</th>
                            <th>Position Tarif.</th>
                            <th>Marchandise</th>
                            <th>Poids</th>
                            <th>CIF</th>
                            <th>Dev</th>
                        </tr>
                    </thead>
                    <tbody>

                        {
                            data.data.map(d => {
                                return (
                                    <tr>
                                        <td>{d.transport.plaques}</td>
                                        <td>
                                            <p dangerouslySetInnerHTML={{ __html: formattedText(d.consignee_name) }} style={{ maxLines: 1 }} ></p>
                                        </td>
                                        <td>
                                            <a href={"/details/zra/" + d.refDeclaration} target="_blank" rel="noopener noreferrer">{d.refDeclaration}</a>
                                        </td>
                                        <td>{d.registration_date}</td>
                                        <td>{d.modele}</td>
                                        <td>{d.items}</td>
                                        <td>{d.principal.tarif.position} : {d.principal.tarif.description}</td>
                                        <td dangerouslySetInnerHTML={{ __html: d.principal.goods_description }} />
                                        <td>{d.poids}</td>
                                        <td>{d.cif}</td>
                                        <td>{d.currency}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
            {
                data.nombre > data.limite && <Pagination totalItems={data.nombre} currentPage={data.page} itemsPerPage={data.limite} />
            }
        </>
    )
}

export default ResultatZambie